<template>
<div class="main">
    <TopCtrl/>
    <PhoneModal ref="phone"/>
    <!-- <CardSearch type="text" placeholder="输入订单号搜索" @change="(v) => this.data.word = v" @search="()=>{ this.handleSearch()}"/> -->
    
    <CardFilter @handleSelected="handleSelected" @handleControl="handleControl" @handleSelectAll="handleSelectAll" @handleDelete="handleDelete" @reload="reload" :count="count" :controlType="controlType"/>
    <van-list class="card-list" :class="{ 'card-list-checked' : showChecked }" v-model="loading" :finished="finished" @load="onLoad">
        <CardItem v-for="c in cardList" :key="'CardItem-' + c.gainId" :card="c" :showChecked="showChecked" @reload="reload" @phone="handlePhone"/>
    </van-list>

    <ActionButton v-if="data.word" text="查看全部卡包" @click="showAll" />
    
    <EmptyListTip 
              :icon="require('../../assets/icon-empty-products.png')" 
              text="卡包空空如也~"
              v-if="count <= 0 && !loading"/>
    
</div>
  
</template>

<script>
import PhoneModal from "@/components/common/Modal/PhoneModal";
import CardFilter from "@/components/orders/CardFilter";
import CardItem from "@/components/orders/CardItem";
import CardSearch from "@/components/orders/CardSearch";
import ActionButton from "@/components/products/form/ActionButton";

import api from "../../api";

var onloadTimer;

export default {
  title: "我的卡包",
  bodyClass: "gray-bg",
  components: { CardFilter, CardItem, CardSearch, ActionButton ,PhoneModal},
  data() {
    return {
      count: 0,
      cardCount: 0,
      cardList: [],
      selectTypes: [],
      controlType: 0,

      // load
      list: [],
      loading: false,
      finished: false,

      data: {
        lastId: "",
        limit: 10,
        openStatus: "",
        selectTypeCode: "",
        word: "",
        startDate: "",
        endDate: "",
      },

      // showchecked
      showChecked: false
    };
  },
  methods: {
    // 搜索
    // handleSearch() {
    //   this.cardList = [];
    //   this.data.lastId = "";
    //   this.onLoad();
    // },
    handlePhone(){
      this.$refs.phone.display();
    },
    // 开卡后需要reload
    reload() {
      for (let i in this.data) {
        this.data[i] = "";
      }
      this.data.limit = 10;
      this.cardList = [];
      this.data.lastId = "";
      this.showChecked = false;
      this.onLoad();
    },

    onLoad() {
      clearTimeout(onloadTimer);
      onloadTimer = setTimeout(()=>{
        let options = this.data;
        let lastId = this.data.lastId;
        let limit = this.data.limit;
        let openStatus = this.data.openStatus;
        let selectTypeCode = this.data.selectTypeCode;
        let word = this.data.word;
        let startDate = this.data.startDate;
        let endDate = this.data.endDate;
        api.wallet.getMyCards(
          lastId,
          limit,
          openStatus,
          selectTypeCode,
          word,
          startDate,
          endDate,
          data => {
            if (!data.hasMore) {
              this.loading = false;
              this.finished = true;
            }
            console.log('onLoad(), cardList.length='+this.cardList.length);
            for (let i = 0; i < data.cards.length; i++) {
              data.cards[i]["checked"] = false;
              this.cardList.push(data.cards[i]);
            }
            this.data.lastId = data.lastId;
            this.count = data.count;
            this.loading = false;
          },
          r => {
            this.loading = false;
            this.finished = true;
            this.$alertDialog(r.msg);
          }
        );
      }, 300);
      
    },
    handleSelected(data) {
      this.data.openStatus = data.status;
      this.data.selectTypeCode = data.type;
      this.data.startDate = data.startDate;
      this.data.endDate = data.endDate;
      this.cardList = [];
      this.finished = false;
      this.data.lastId = "";
      this.onLoad();
    },
    showAll() {
      this.$router.replace("/pages/orders/Wallet");
      this.data.word = "";
      this.cardList = [];
      this.data.lastId = "";
      this.onLoad();
    },
    handleControl(type) {
      this.showChecked = type;
      this.controlType = type;
      if (type == 0) {
        for (let i = 0; i < this.cardList.length; i++) {
          this.cardList[i]["checked"] = false;
        }
      }
    },
    handleSelectAll(type) {
      for (let i = 0; i < this.cardList.length; i++) {
        let d = this.cardList[i];
        if (type) {
          if (d.opened) {
            d["checked"] = true;
          } else {
            d["checked"] = false;
          }
        } else {
          d["checked"] = false;
        }
      }
    },
    handleDelete() {
      this.cardCount = 0;
      let gainIds = [];
      for (let i = 0; i < this.cardList.length; i++) {
        let d = this.cardList[i];
        if (d.checked) {
          this.cardCount += 1;
          gainIds.push(d.gainId);
        }
      }
      gainIds = gainIds.toString();
      if (this.cardCount == 0) {
        this.$toast("请选择你要删除的卡券");
      } else {
        this.$confirmDialog(
          "选中" + this.cardCount + "张卡券，是否确认删除",
          btn => {
            if (btn == "确定") {
              api.wallet.deleteCard(
                gainIds,
                res => {
                  this.$toast("删除成功");
                  this.reload();
                  this.controlType = 0;
                },
                r => {
                  this.$alertDialog(r.msg);
                }
              );
            }
          }
        );
      }
    }
  },
  created() {
    var orderno = this.$route.query.orderno;
    if (orderno) {
      this.data.word = orderno;
    }
  }
};
</script>

<style scoped lang="less">
.card-list {
  margin-top: 11.8vw;
  padding-top: 5vw;
}
.card-list-checked {
  margin-bottom: 15vw;
}
</style>




// WEBPACK FOOTER //
// src/pages/orders/Wallet.vue